import React, { useEffect, useState } from 'react';
import ImageUploader from 'react-images-upload';
import { getStorage, ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload, faXmark } from '@fortawesome/free-solid-svg-icons';
import { useApi } from '../Store/ApiContext';
import Spinner from '../Spinner/Spinner';
import { useTranslation } from 'react-i18next';
import { nanoid } from 'nanoid';
import { enqueueSnackbar } from 'notistack';
import { constantsErrorMessage } from '../../constants/global';

const UploadImages = ({ unitCode, data, setData }) => {

  const { getSlug } = useApi();
  const { t } = useTranslation();

  const [uploadedMediaUrls, setUploadedMediaUrls] = useState([]);
  const [isUploading, setIsUploading] = useState(false);

  // Helper function to determine if URL is a video
  const isVideo = (url) => {
    const videoExtensions = ['.mp4', '.avi', '.mov', '.wmv', '.flv', '.webm', '.mkv'];
    const urlLower = url.toLowerCase();
    return videoExtensions.some(ext => urlLower.includes(ext));
  };

  const handleImageUpload = async (images) => {
    const files = (images.target.files);
    setIsUploading(true);
    try {
      const slug = getSlug();
      const storage = getStorage();
      const storageRef = ref(storage, `unitsMedia/${slug}/${unitCode}`); //unitsMedia is the folder we will upload media to it
      const uploadedMediaUrl = [];

      for (let i = 0; i < files.length; i++) {
        console.log(files[i].size);

        if (files[i].size <= 21288010) { // 20 MB size limit
          const image = files[i];
          // Get file extension
          const fileExtension = image.name.substring(image.name.lastIndexOf('.'));
          // Create unique name with nanoid and timestamp
          const uniqueName = `${nanoid()}_${Date.now()}${fileExtension}`;

          const imageRef = ref(storageRef, uniqueName);
          await uploadBytes(imageRef, image);

          const downloadURL = await getDownloadURL(imageRef);
          // Store the downloadURL in your database
          // console.log('Download URL:', downloadURL.split('?')[0] + "?alt=media");
          uploadedMediaUrl.push(downloadURL.split('?')[0] + "?alt=media")
        } else {
          enqueueSnackbar(<>{t(constantsErrorMessage)}<br />لقد تعديت الحد المسموح به 20 ميغابايت</>, { variant: "warning" });
        }
        setUploadedMediaUrls([...uploadedMediaUrls, ...uploadedMediaUrl,]);
      }
    } catch (error) {
      console.error('Upload error:', error);
    } finally {
      setIsUploading(false);
    }
  };

  async function handleImageRemoveStorage(image) {
    // Extract the filename from the URL
    // The URL format is: https://...../unitsMedia%2F{slug}%2F{unitCode}%2F{filename}?alt=media
    const imageName = image.split('%2F').reverse()[0].split("?")[0];
    console.log('Deleting image:', imageName);

    const storage = getStorage();
    const slug = getSlug();
    const desertRef = ref(storage, `unitsMedia/${slug}/${unitCode}/${imageName}`);

    // Delete the file
    try {
      await deleteObject(desertRef);
      console.log('Image deleted successfully from storage');
    } catch (error) {
      console.error('Error deleting image from storage:', error);
    }

    // Remove from local state
    const myUrls = [...data.media]
    for (let i = 0; i < myUrls.length; i++) {
      if (myUrls[i].split('%2F').reverse()[0].split("?")[0] === imageName) {
        myUrls.splice(i, 1);
        break; // Exit loop after finding and removing the item
      }
    }
    setUploadedMediaUrls(myUrls);
  }

  // const handleImageRemove = (image) => {
  //   console.log(image.split('%2F').reverse()[0].split("?")[0]);
  //   const storage = getStorage();
  //   const slug = getSlug();
  //   console.log(slug);
  //   const desertRef = ref(storage, `unitsMedia/${slug}/${unitCode}/${image.name}`);

  //   // Delete the file
  //   deleteObject(desertRef).then(() => {
  //   // File deleted successfully
  //   const myFiles = [...uploadedImages]
  //   for (let i = 0; i < myFiles.length; i++) {
  //     if (myFiles[i].name === image.name) {
  //       myFiles.splice(i, 1);
  //     }
  //   }
  //   setUploadedImages(myFiles)
  //   const myUrls = [...uploadedMediaUrls]
  //   for (let i = 0; i < myUrls.length; i++) {
  //     if (myUrls[i].split('%2F').reverse()[0].split("?")[0] === image.name) {
  //       console.log(myUrls[i]);
  //       myUrls.splice(i, 1);
  //     }
  //   }
  //   setUploadedMediaUrls(myUrls)
  //   }).catch((error) => {
  //   // Uh-oh, an error occurred!
  //   });
  // };

  useEffect(() => {
    if (data.media.length) {
      setUploadedMediaUrls(data.media)
    }
  }, [])

  useEffect(() => {
    let myData = { ...data }
    myData.media = uploadedMediaUrls
    setData(myData)
    console.log(myData.media);
  }, [uploadedMediaUrls])

  return (
    <div>
      <div className='text-center '>
        <p className='label-upload'>الحد الأقصى لحجم الملف: 20 ميغا بايت</p>
        <input id='uploadMedia' multiple accept="video/*, image/*" type='file' className='inputfile' onChange={handleImageUpload} disabled={isUploading} />
        <label htmlFor="uploadMedia" className={`py-3 ${isUploading ? 'disabled' : ''}`}>
          {isUploading ? <div className="text-center my-3">
            <Spinner height={38} />
            <p>{t("uploadingFiles")}</p>
          </div> : <FontAwesomeIcon className='icon-upload-image' icon={faUpload} />}
        </label>
      </div>

      {/* {isUploading && (
        <div className="text-center my-3">
          <Spinner />
          <p>{t("uploadingFiles")}</p>
        </div>
      )} */}

      {/* <ImageUploader
        withIcon={false}
        // onChange={(e) => {handleFiles(e)}}
        withPreview={true}
        accept="video/*, image/*"
        imgExtension={['.jpg', '.jpeg', '.gif', '.png', '.mp4', ".webp"]}
        maxFileSize={5242880}
        label="الحد الأقصى لحجم الملف: 5 ميغا بايت ، مقبول: jpg | jpeg | png | mp4"
        buttonText={<FontAwesomeIcon className='icon-upload-image' icon={faUpload} />}
        buttonClassName="btn-upload-files"
      /> */}
      {/* <div className='row'>
        {uploadedImages.map((image, index) => (
          <div className='col-md-3 image-preview' key={index}>
            <img className='w-100' src={URL.createObjectURL(image)} alt="uploaded" />
            <button className='icon-delete-image' onClick={() => handleImageRemove(image)}><FontAwesomeIcon icon={faXmark} /></button>
          </div>
        ))}
      </div> */}
      <div className='row g-4'>
        {data?.media?.map((url, index) => (
          <div className='col-md-3 image-preview' key={index}>
            {isVideo(url) ? (
              <video className='w-100' controls>
                <source src={url} type="video/mp4" />
                {t("yourBrowserDoesNotSupportTheVideoTag")}
              </video>
            ) : (
              <img className='w-100' src={url} alt="uploaded" />
            )}
            <button className='icon-delete-image' onClick={() => handleImageRemoveStorage(url)}><FontAwesomeIcon icon={faXmark} /></button>
          </div>
        ))}
      </div>
      {/* <button onClick={handleImageSubmit}>Submit Images</button> */}
    </div>
  );
};

export default UploadImages;